import _ from 'lodash';

import Store from 'lib/Store';
import Messages from 'collections/Messages';
import Message from 'entities/Message';
import { getGroupKey } from 'utils/roleHelpers';
import { ActionTypes, LoadingStates } from '../constants/GroupConstants';

const getGroupKeys = (message: Message): Array<string | number> => {
  // threads from the server are guaranteed to have group ids
  const threadKeys = message.getGroupThreads().map((t) => getGroupKey(t.group_id, t.role));
  // XXX rgoldfinger why do messages in tests only have targets?
  const targetKeys = message.getTargets().map(
    // $FlowFixMe target types messed up
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'group_id' does not exist on type 'Target... Remove this comment to see the full error message
    (t) => getGroupKey(t.group_id, t.role)
  );
  return _.uniq([...threadKeys, ...targetKeys]);
};

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class MessageStore extends Store {
  getInitialState() {
    return {
      messages: {},
      messagesScheduled: {},
      loadingState: {},
      gaps: {},
    };
  }

  doMessage(dict: any, method: any, message: any) {
    const groupKeys = getGroupKeys(message);
    let changed = false;

    groupKeys.forEach((groupKey) => {
      let messages = dict[groupKey];
      if (!messages) {
        dict[groupKey] = new Messages();
        messages = dict[groupKey];
      }
      messages[method](message);
      changed = true;
    });

    if (changed) {
      this.emitChange();
    }
  }

  addMessage(message: Message) {
    // This is when a message was scheduled, then an edit
    // was made that unscheduled it, so it should be removed
    // from the scheduled messages list before adding
    this.doMessage(this.state.messages, 'add', message);
  }

  removeMessage(message: Message) {
    this.doMessage(this.state.messages, 'remove', message);
  }

  removeClientCreatedDuplicates(groupKey: Backbone$Id, newMessages: Messages) {
    const dupes = this.state.messages[groupKey].filter(
      // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'm' implicitly has an 'any' type.
      (m) => m.getIsClientCreated() === true && newMessages.some((n) => n.getBody() === m.getBody())
    );
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'd' implicitly has an 'any' type.
    dupes.forEach((d) => this.state.messages[groupKey].remove(d));
  }
  getGap(groupKey: Backbone$Id) {
    return this.state.gaps[groupKey];
  }

  isDoneLoadingForGroup(groupKey: Backbone$Id) {
    return this.state.loadingState[groupKey] === LoadingStates.LOADED;
  }
  getMessages(groupKey: Backbone$Id) {
    return this.state.messages[groupKey] || new Messages();
  }

  handleDispatch(action: any): void {
    switch (action.type) {
      case ActionTypes.RESET_STORE:
        this.resetState();
        break;
      case ActionTypes.SEND_GROUP_MESSAGE:
        this.addMessage(action.message);
        break;
      case ActionTypes.SEND_GROUP_MESSAGE_ERROR:
        this.removeMessage(action.message);
        break;
      case ActionTypes.LIST_GROUP_MESSAGES: {
        const { groupKey, messages } = action;
        if (!this.state.messages[groupKey]) {
          this.state.messages[groupKey] = new Messages();
        }
        this.state.loadingState[groupKey] = LoadingStates.LOADED; // assume this is the end until we see a gap
        this.state.gaps[groupKey] = undefined;
        this.removeClientCreatedDuplicates(groupKey, messages);
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'message' implicitly has an 'any' type.
        messages.forEach((message) => {
          const type = message.getType();
          if (type === 'message' || type === 'payment_request') {
            this.state.messages[groupKey].add(message);
          } else if (type === 'gap') {
            this.state.gaps[groupKey] = message;
          }
        });
        this.emitChange();
        break;
      }
      default:
        break;
    }
  }
}
export default new MessageStore();
